import React, { useState, useEffect } from 'react';
import { Typography, Box } from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';
import { isEmpty } from 'lodash';
import Page from 'Components/Page';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import CenteredSpinner from '../../Components/CenteredSpinner';
import grey from '@material-ui/core/colors/grey';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import clsx from 'clsx';
import TokensNavbar from '../../Components/TokensNavbar';
import Container from 'Components/Container';
import Collapse from '@material-ui/core/Collapse';

const pageStyles = theme => ({
  pageWrapper: {
    '& p': {
      margin: 0,
    }
  },
  tokenImage: {
    width: '100%',
    margin: 'auto',
  },
  table: {
    fontWeight: '.5rem',
  },
  infoContainer: {
    backgroundColor: '#ffffff',
  },
  infoContainerContents: {
    display: 'flex',
  },
  tokenType: {
    color: grey[500],
  },
  extraInfo: {
    fontSize: '15px',
    wordBreak: 'break-word',
    '& span': {
      marginRight: '8px',
      color: grey[400],
    },
  },
  tokenCreator: {
    color: grey[500],
  },
  tokenOwner: {
    color: grey[500],
    marginTop: '24px',
  },
  description: {
    color: grey[700],
    marginTop: '24px',
  },
  imageHash: {
    color: grey[700],
    marginTop: '24px',
  },
  video: {
    maxWidth: '100%',
    maxHeight: '500px',
    outline: 'none',
  },
  extraInfoContainer: {
    '@media (max-width: 720px)': {
      flexDirection: 'column',
    },
  },
  tokenId: {
    '@media (max-width: 720px)': {
      marginTop: '16px',
    },
  },
  ownersArea: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  ownerGrid: {
    marginTop: '24px',
    border: '1px solid #999',
    display: 'grid',
    gridTemplateColumns: '100px auto',
  },
  firstOwnerGrid: {
    marginTop: 0,
  },
  ownerInfo: {
    fontSize: '14px',
    borderBottom: '1px solid #999',
  },
  ownerInfoHeader: {
    borderRight: '1px solid #999',
    padding: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  ownerInfoData: {
    padding: '8px',
    wordBreak: 'break-all',
    textAlign: 'left',
  },
  ownerInfoLast: {
    borderBottom: 'none',
  },
  expandButton: {
    cursor: 'pointer',
    color: '#4D5153',
    fontSize: 15,
    userSelect: 'none',
  },
  topContainer: {
    backgroundColor: '#1B1C1D',
  },
  topContainerBar: {
    paddingTop: '30px',
    paddingBottom: '30px',
    borderBottom: '1px solid #313739',
  },
  topContainerBarContents: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  tokenName: {
    fontFamily: "'Nunito Sans', sans-serif",
    fontWeight: 700,
    fontSize: '32px',
    letterSpacing: '0.24px',
    lineHeight: '44px',
    color: '#FAFAFA',
  },
  verifiedText: {
    fontFamily: "'Work Sans', sans-serif",
    fontWeight: 600,
    color: '#08BE64',
    fontSize: '14px',
    letterSpacing: '0.11px',
    lineHeight: '16px',
  },
  galleryContainer: {
    paddingTop: 64,
    paddingBottom: 64,
  },
  section: {
    marginTop: '23px',
  },
  accordian: {
    '& a': {
      color: '#08BE64',
      textDecoration: 'none',
    }
  },
  accordianTopBar: {
    padding: '19px 14px',
    backgroundColor: '#FAFAFA',
    borderTop: '1px solid #EDEDED',
    borderBottom: '1px solid #D8D8D8',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
  },
  accordianTitle: {
    fontFamily: "'Montserrat', sans-serif",
    color: '#4D5153',
    fontSize: '16px',
    fontWeight: '500',
    letterSpacing: '0.12px',
    lineHeight: '19px',
  },
  accordianContent: {
    padding: '16px 14px',
  },
  accordianRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '4px',
  },
  firstAccordianRow: {
    marginTop: 0,
  },
  accordianLabel: {
    fontFamily: "'Montserrat', sans-serif",
    color: '#939798',
    fontSize: '13px',
    fontWeight: '500',
    letterSpacing: '0.1px',
    lineHeight: '27px',
  },
  accordianInfo: {
    fontFamily: "'Montserrat', sans-serif",
    color: '#4D5153',
    fontSize: '13px',
    fontWeight: '500',
    letterSpacing: '0.1px',
    lineHeight: '27px',
  },
  loader: {
    marginTop: '100px',
  },
});

function Info({ classes, tokenId, contractAddress }) {
  const [tokenInfo, setTokenInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isInfoContentVisible, setIsInfoContentVisible] = useState(true);
  const [isRatingContentVisible, setIsRatingContentVisible] = useState(false);

  useEffect(() => {
    if (!tokenInfo) {
      const getTokenInformation = async () => {
        const ownerfyResponse = await axios.get(
          `https://us-central1-receiptcoin-receiptchain-de560.cloudfunctions.net/app/api/items/${tokenId}`,
        );
        const OpenseaResponse = await axios.get(`https://api.opensea.io/api/v1/asset/${contractAddress}/${tokenId}/`);
        // console.log(`getOwnerfyTokenInformation response`, ownerfyResponse);
        console.log(`getPublicTokenInformation response`, OpenseaResponse);

        setTokenInfo({
          ...tokenInfo,
          ...ownerfyResponse.data,
          owners: OpenseaResponse.data.top_ownerships,
        });

        setTimeout(function(){
            const videoPlayer = document.getElementById('token-video');
            if (videoPlayer) {
              videoPlayer.play();
            }
        },1000);
      };

      getTokenInformation();
    }
  }, [contractAddress, tokenId, tokenInfo]);

  console.log(`tokenInfo`, tokenInfo);

  const getShortAddress = (address) => {
    return `${address.substring(0, 6)}...${address.substring(address.length - 4)}`;
  }

  const Star = () => {
    return <span class="material-icons">star</span>;
  }

  return (
    <Page wrapperStyles={classes.pageWrapper} NavBarComponent={TokensNavbar} hasContainer={false}>
      {tokenInfo ? (
        <div className={classes.topContainer}>
          <Container className={classes.topContainerBarContents} outerContainerClassName={classes.topContainerBar} maxWidth="1025px">
            <p className={classes.tokenName}>{tokenInfo.name}</p>
            <p className={classes.verifiedText}>Verified NFT</p>
          </Container>
          <Container maxWidth="1025px" className={classes.galleryContainer}>
            {tokenInfo.animation_url ? (
              <video id="token-video" controls className={classes.video} autoplay loop
              muted>
                <source src={tokenInfo.animation_url} type="video/mp4" />
                Your browser does not support playing videos.
              </video>
            ) : (
              <img src={tokenInfo.image} alt="Token" className={classes.tokenImage} />
            )}
          </Container>
          <Container maxWidth="1025px" className={classes.infoContainerContents} outerContainerClassName={classes.infoContainer}>
            <div className={classes.section}>
              <div className={classes.accordian}>
                <div className={classes.accordianTopBar} onClick={() => setIsInfoContentVisible(isVisible => !isVisible)}>
                  <p className={classes.accordianTitle}>Info</p>
                  <span className={clsx('material-icons', classes.expandButton)}>expand_{isInfoContentVisible ? 'less' : 'more'}</span>
                </div>
                <div className={classes.accordianContent}>
                  <Collapse in={isInfoContentVisible}>
                    <div className={clsx(classes.accordianRow, classes.firstAccordianRow)}>
                      <p className={classes.accordianLabel}>Token ID</p>
                      <p className={classes.accordianInfo}>{tokenId}</p>
                    </div>
                    <div className={classes.accordianRow}>
                      <p className={classes.accordianLabel}>Blockchain</p>
                      <p className={classes.accordianInfo}>Etherium</p>
                    </div>
                    <div className={classes.accordianRow}>
                      <p className={classes.accordianLabel}>Smart Contract</p>
                      <p className={classes.accordianInfo}><a target="_blank" href={`https://etherscan.io/address/${contractAddress}`}>{getShortAddress(contractAddress)}</a></p>
                    </div>
                    <div className={classes.accordianRow}>
                      <p className={classes.accordianLabel}>Owned by</p>
                      <p className={classes.accordianInfo}><a target="_blank" href={`https://etherscan.io/address/${tokenInfo.owners[0].owner.address}`}>{getShortAddress(tokenInfo.owners[0].owner.address)}</a></p>
                    </div>
                    <div className={classes.accordianRow}>
                      <p className={classes.accordianLabel}>Created by</p>
                      <p className={classes.accordianInfo}>{tokenInfo.creator} <a target="_blank" href={`https://etherscan.io/address/${tokenInfo.owners[0].owner.address}`}>{getShortAddress(tokenInfo.owners[0].owner.address)}</a></p>
                    </div>
                  </Collapse>
                </div>
              </div>

              <div className={classes.accordian}>
                <div className={classes.accordianTopBar} onClick={() => setIsRatingContentVisible(isVisible => !isVisible)}>
                  <p className={classes.accordianTitle}><Star /><Star /><Star /><Star /><Star /> NFT Authenticity Rating</p>
                  <span className={clsx('material-icons', classes.expandButton)}>expand_{isInfoContentVisible ? 'less' : 'more'}</span>
                </div>
                <div className={classes.accordianContent}>
                  <Collapse in={isRatingContentVisible}>
                    <div className={clsx(classes.accordianRow, classes.firstAccordianRow)}>
                      <p className={classes.accordianLabel}>Token ID</p>
                      <p className={classes.accordianInfo}>{tokenId}</p>
                    </div>
                    <div className={classes.accordianRow}>
                      <p className={classes.accordianLabel}>Blockchain</p>
                      <p className={classes.accordianInfo}>Etherium</p>
                    </div>
                    <div className={classes.accordianRow}>
                      <p className={classes.accordianLabel}>Smart Contract</p>
                      <p className={classes.accordianInfo}><a target="_blank" href={`https://etherscan.io/address/${contractAddress}`}>{getShortAddress(contractAddress)}</a></p>
                    </div>
                    <div className={classes.accordianRow}>
                      <p className={classes.accordianLabel}>Owned by</p>
                      <p className={classes.accordianInfo}><a target="_blank" href={`https://etherscan.io/address/${tokenInfo.owners[0].owner.address}`}>{getShortAddress(tokenInfo.owners[0].owner.address)}</a></p>
                    </div>
                    <div className={classes.accordianRow}>
                      <p className={classes.accordianLabel}>Created by</p>
                      <p className={classes.accordianInfo}>{tokenInfo.creator} <a target="_blank" href={`https://etherscan.io/address/${tokenInfo.owners[0].owner.address}`}>{getShortAddress(tokenInfo.owners[0].owner.address)}</a></p>
                    </div>
                  </Collapse>
                </div>
              </div>
            </div>
            <div className={classes.section}>Right side</div>
          </Container>
        </div>
      ) : (
        <CenteredSpinner className={classes.loader} />
      )}
    </Page>
  );
}

function mapStateToProps(state, ownProps) {
  return {
    tokenId: ownProps.match.params.tokenId,
    contractAddress: ownProps.match.params.contractAddress,
  };
}

export default withRouter(connect(mapStateToProps, null)(withStyles(pageStyles)(Info)));

{/* <Typography variant="body1" className={classes.description}>
              {tokenInfo.description}
            </Typography> */}

{/* 
  Keep this for later if we need to access the owners information for fungible tokens
  
  <div className={classes.ownersArea}>
  {tokenInfo.owners.map((ownerInfo, index) => (
    <div className={clsx(classes.ownerGrid, index === 0 && classes.firstOwnerGrid)}>

        <Typography variant="body1" className={clsx(classes.ownerInfo, classes.ownerInfoHeader)}>
          <strong>Address</strong>
        </Typography>
        <Typography variant="body1" className={clsx(classes.ownerInfo, classes.ownerInfoData)}>
          {ownerInfo.owner.address}
        </Typography>

        <Typography variant="body1" className={clsx(classes.ownerInfo, classes.ownerInfoHeader, index + 1 === tokenInfo.owners.length && classes.ownerInfoLast)}>
          <strong>Quantity</strong>
        </Typography>
        <Typography variant="body1" className={clsx(classes.ownerInfo, classes.ownerInfoData, index + 1 === tokenInfo.owners.length && classes.ownerInfoLast)}>
          {ownerInfo.quantity} 
        </Typography>

    </div>
  ))}
</div> */}
